import auth from '@react-native-firebase/auth';
import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { influencerScheduleTilePressed } from '../Planner/plannerActions';
import Theme from '../theme';
import { LoadingModal } from '../ui';
import { AppStateFocusedEvents } from '../ui/components/AppStateFocusedEvents';
import { clearDeepLinkParams } from '../utils/notifications/actions';
import { InfluencerInviteScreen } from './InfluencerInviteScreen';
import { InfluencerNoScheduleScreen } from './InfluencerNoScheduleScreen';
import { InfluencerWithSlotsScreen } from './InfluencerWithSlotsScreen';
import { useInfluencerData } from './useInfluencerData';

interface IProps {
  navigation: any;
  influencerId: string;
  workoutTilePressed: (bookingTime: number, inviteId: string, influencerName: string) => void;
  clearDeepLinkParamsForInfluencerId: () => void;
}

const InfluencerContainerComponent = ({
  navigation,
  workoutTilePressed,
  clearDeepLinkParamsForInfluencerId,
  ...restProps
}: IProps) => {
  useEffect(() => {
    return () => {
      clearDeepLinkParamsForInfluencerId();
    };
  }, []);
  const influencerId = navigation.getParam('influencerId') || restProps.influencerId;
  const [screenFocussed, setScreenFocussed] = useState(true);
  const {
    influencerBookings,
    influencerName,
    isLoadingBookings,
    avatar,
    isLoadingAvatar,
    landingPage,
    personalisedHeader,
  } = useInfluencerData(influencerId, screenFocussed);
  const hasBookings = influencerBookings.length > 0;
  const showLoadingModal = isLoadingBookings || isLoadingAvatar;
  const hasFetchedBookings = !isLoadingBookings;
  const isUserLoggedIn = !!auth().currentUser;
  const shouldShowNoScheduleScreen = hasFetchedBookings && isUserLoggedIn && !hasBookings;
  const shouldShowScheduleScreen = hasFetchedBookings && hasBookings;
  const onScreenFocus = () => {
    setScreenFocussed(true);
  };
  const onScreenUnfocus = () => {
    setScreenFocussed(false);
  };

  if (showLoadingModal) {
    return (
      <View style={styles.container}>
        <AppStateFocusedEvents
          onScreenFocus={onScreenFocus}
          onScreenUnfocus={onScreenUnfocus}
          navigation={navigation}
         />
        <LoadingModal isLoading={showLoadingModal} />
      </View>
    );
  }
  if (shouldShowNoScheduleScreen) {
    return (
      <>
        <AppStateFocusedEvents
          onScreenFocus={onScreenFocus}
          onScreenUnfocus={onScreenUnfocus}
          navigation={navigation}
        />
        <InfluencerNoScheduleScreen
          avatar={avatar}
          influencerName={influencerName}
          navigation={navigation}
          personalisedHeader={personalisedHeader}
        />
      </>
    );
  }

  if (shouldShowScheduleScreen) {
    return (
      <>
        <AppStateFocusedEvents
          onScreenFocus={onScreenFocus}
          onScreenUnfocus={onScreenUnfocus}
          navigation={navigation}
        />
        <InfluencerWithSlotsScreen
          influencerBookings={influencerBookings}
          influencerId={influencerId}
          influencerName={influencerName}
          avatar={avatar}
          workoutTilePressed={(bookingTime, inviteId) => {
            workoutTilePressed(bookingTime, inviteId, influencerName);
          }}
          navigation={navigation}
          clearDeepLinkParamsForInfluencerId={
            clearDeepLinkParamsForInfluencerId
          }
        />
      </>
    );
  }

  return (
    <>
      <AppStateFocusedEvents
        onScreenFocus={onScreenFocus}
        onScreenUnfocus={onScreenUnfocus}
        navigation={navigation}
      />
      <InfluencerInviteScreen
        influencerName={influencerName}
        navigation={navigation}
        influencerId={influencerId}
        avatar={avatar}
        landingPage={landingPage}
        personalisedHeader={personalisedHeader}
      />
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    backgroundColor: Theme.WHITE,
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    workoutTilePressed: (bookingTime: number, inviteId: string, influencerName: string) => {
      dispatch(influencerScheduleTilePressed(bookingTime, inviteId, influencerName));
    },
    clearDeepLinkParamsForInfluencerId: () =>
      dispatch(clearDeepLinkParams(['influencerId'])),
  };
};

const mapStateToProps = (state) => {
  return {
    influencerId: state.deepLinkParamaters.influencerId,
  };
};

export const InfluencerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InfluencerContainerComponent);
